export default __webpack_public_path__ + "static/media/comedor-desktop.dcd98872.png";